let _deviceRotateConfirmed = false;

export function getDeviceRotateConfirmed() {
  return _deviceRotateConfirmed;
}

export function setDeviceRotateConfirmed(value: boolean) {
  _deviceRotateConfirmed = value;
}

export function resetDeviceRotateState() {
  _deviceRotateConfirmed = false;
}
